
import React, { PureComponent, Component } from 'react';
import { observer } from 'mobx-react'
import { Form, FormRenderProps } from 'react-final-form';
import { action, observable, runInAction } from 'mobx';
import { FormApi } from 'final-form';
import { AxiosResponse } from 'axios';
import { url } from '@matchlighter/common_library/lib/strings';

import { View } from "@instructure/ui-view";
import { Flex } from "@instructure/ui-flex";
import { Footer } from '@/shared_components/Footer';
import { Button } from '@instructure/ui-buttons';
import { Modal } from '@instructure/ui-modal';
import { Heading } from '@instructure/ui-heading';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';

import { env } from '@/environment';
import { API } from '@/api';

import { ProvideContexts } from '@/shared_components/ProvideContexts';
import { PromptProvider, PromptContainer } from '@/shared_components/PromptManager';
import { AlertProvider, AlertsContainer } from '@/shared_components/AlertManager';
import { FormPageAlerts, transformFormErrors } from '@/shared_components/final_form/components';
import { DemographicFormFields, serializeDemographicForm } from '@/shared_components/DemographicForm';
import { FormSubmitButton, FormSubmitDisabledReason } from '@/shared_components/form/FormSubmitButton';
import { Header } from '@/shared_components/Header';

import './index.scss';

@observer
export class App extends PureComponent {

    private redirectLocation: string;
    @observable showCheckEmailModal = false;

    @action.bound
    async onSubmitForm(values, form: FormApi) {
        let response: AxiosResponse;
        try {
            response = await API.post(`registration/`, {
                demographic_data: serializeDemographicForm(values),
            })
            form.initialize(values)
            if (response.data.redirect) {
                runInAction(() => {
                    this.redirectLocation = response.data.redirect;
                    this.showCheckEmailModal = true;
                })
            }
        } catch (err) {
            return transformFormErrors(err);
        }
    }

    @action.bound
    handleCancel() {
        const params = env.catalog_context;
        window.location = url`${params['catalog_url']}/courses/${params['product_path']}` as any;
    }

    @action.bound
    handleModalClose() {
        window.location = this.redirectLocation as any;
    }

    get loginUrl() {
        const params = env.catalog_context;
        const catalog_url = new URL(params['catalog_url']);
        const return_uri = url`/courses/${params['product_id']}/enrollment/new`;
        return url`${catalog_url.origin}/login?target_uri=${encodeURIComponent(return_uri)}`;
    }

    renderForm = ({ form, handleSubmit, submitting, dirty }: FormRenderProps) => {
        return <>
            <FormPageAlerts />

            <div className="form-wrapper">
                <View as="div" padding="0 large" position="relative" margin="0 0 large">
                    <DemographicFormFields confirm_email />
                </View>
            </div>
            <Footer>
                <Flex direction="row" justifyItems="end" alignItems="center" margin="0 0 large">
                    <FormSubmitDisabledReason />
                    <Button interaction={submitting ? 'disabled' : 'enabled'} margin="0 0 0 x-small" onClick={this.handleCancel}>Cancel</Button>
                    <FormSubmitButton handleSubmit={handleSubmit} margin="0 0 0 x-small">Register</FormSubmitButton>
                </Flex>
            </Footer>
        </>
    }

    render() {
        return <ProvideContexts contexts={[PromptProvider, AlertProvider]}>
            <PromptContainer />
            <AlertsContainer />

            <div className="app-wrapper">
                <div className="header-wrapper">
                    <Header title={"User Registration"} teaLogo actionAlign="flex-end">
                        <div style={{ marginRight: '1rem' }}>
                            <Text size="medium" color="primary">
                                Already registered? <Link href={this.loginUrl}>Sign In</Link>
                            </Text>
                        </div>
                    </Header>
                    <div className="dummy-tabbar" />
                </div>

                <div className="content-wrapper" style={{ overflow: 'hidden' }}>
                    <Form
                        onSubmit={this.onSubmitForm}
                        render={this.renderForm}
                    />
                </div>
            </div>
            <CheckEmailModal open={this.showCheckEmailModal} handleClose={this.handleModalClose} />
        </ProvideContexts>
    }
}

class CheckEmailModal extends Component<{ open: boolean, handleClose: () => void }> {
    render() {
        return <Modal
            open={this.props.open}
            onDismiss={this.props.handleClose}
            size="medium"
            label="Modal Dialog: Complete Registration"
            shouldCloseOnDocumentClick
        >
            <Modal.Header>
                <Heading>Complete Registration</Heading>
            </Modal.Header>
            <Modal.Body>
                <Text>
                    Please check your email now to complete your registration.
                </Text>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.props.handleClose} color="primary">Continue</Button>
            </Modal.Footer>
        </Modal>
    }
}
